import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox } from '@reveni-io/reveni-ui'

import ShippingMethod from '@/configuration/components/ShippingMethod/ShippingMethod'

import * as Styles from './styles'

const ShippingMethodList = ({
  shippingMethods,
  locations,
  regions,
  locationToDelete,
  changeLocationIdOfShippingMethod,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const availableLocations = locations?.filter(location => location.id !== locationToDelete?.id)

  return (
    <Styles.MainContainer>
      {shippingMethods?.map(shippingMethod => (
        <Styles.ShipmentMethodContainer key={shippingMethod.id}>
          <ShippingMethod
            data={shippingMethod}
            regions={regions}
            isEditable={false}
            showSwitch={false}
            customBackgroundColor={theme.colors.background.secondary}
          />
          <ComboBox
            label={t('Nueva ubicación de destino')}
            backgroundColor={theme.colors.background.primary}
            value={shippingMethod.new_location_id}
            menuItems={availableLocations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id }))}
            handleChange={e => changeLocationIdOfShippingMethod(e.target.value, shippingMethod.id)}
          />
        </Styles.ShipmentMethodContainer>
      ))}
    </Styles.MainContainer>
  )
}

export default ShippingMethodList
